import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-teamdashboard',
  templateUrl: './teamdashboard.component.html',
  styleUrls: ['./teamdashboard.component.css']
})
export class TeamdashboardComponent implements OnInit {

    @Output() mydashboardProfiletab: EventEmitter<string> = new EventEmitter<string>();
    userid: any;
    tenantid: any;
    view: any[] = [600, 200];
    single = [
        {
            "name": "Germany",
            "value": 8940000
        },
        {
            "name": "USA",
            "value": 5000000
        }

    ];

    // options
    gradient: boolean = false;
    showLegend: boolean = false;
    showLabels: boolean = false;
    isDoughnut: boolean = false;


    series = [
        {
            "name": "Retired",
            "value": 20,
            "label": "20%"
        },
        {
            "name": "Employed",
            "value": 70,
            "label": "70%"
        },
        {
            "name": "Unemployed",
            "value": 10,
            "label": "10%"
        }
    ];

    //color scheme for billable section
    colorScheme = {
        domain: ['#1BC5BD', '#F53B57']
    };

    colorSchemeLeave = {
        domain: ['#56D9FE', '#FFA800']
    };

    // hide show div
    isShown: boolean = true; // shown by default
    isShown_grid: boolean = false; // hidden by default

    leavesCards = [
        { id: 1, name: 'ArrivalTime', price: '09:30 hours', icon: 'assets/common/images/users/Available balance.svg', class: 'text-success' },
        { id: 2, name: 'leftTime', price: 'ONLINE', icon: 'assets/common/images/Activities/leftTimeIcon.svg', class: 'leftIconcolor' },
        { id: 3, name: 'ProductiveTime', price: '09:30 hours', icon: 'assets/common/images/users/Balance after booked.svg', class: 'text-primary' },
        { id: 4, name: 'IntimeProsTime', price: '09:30 hours', icon: 'assets/common/images/Activities/ITPtimeIcon.svg', class: 'pngcolorchange' },
        { id: 5, name: 'TimeAtWork', price: '09:30 hours', icon: 'assets/common/images/Activities/timeAtWork.svg', class: 'text-danger' },
        { id: 6, name: 'PlacedinGroup', price: '3rd', icon: 'assets/common/images/Activities/placedGroup.svg', class: 'text-info' },
        { id: 7, name: 'Effectiveness', price: '80%', icon: 'assets/common/images/Activities/EffectiveDashboard.svg', class: 'text-warning' },
        { id: 8, name: 'Productivity', price: '80%', icon: 'assets/common/images/Activities/ProductivityDashboard.svg', class: 'text-danger' }

    ];


    //Array for Team Details
    teamDetails = [
        { id: 1, MemberName: 'Franis Lawrence', ProjectName: 'ATP jobs', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', currentlyusing: 'Adobe XD', proStatus: 'Productive', icon: 'assets/common/images/Activities/AdobeIcon.png' },
        { id: 2, MemberName: 'Leo Messi', ProjectName: 'WFM One', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Pending', currentlyusing: 'Absent', proStatus: ' ', icon: 'assets/common/images/Activities/absentIcon.svg' },
        { id: 3, MemberName: 'Steve Rogers', ProjectName: 'ITP', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Approved', currentlyusing: 'Outlook', proStatus: 'Neutral', icon: 'assets/common/images/Activities/microsoft.png' },
        { id: 4, MemberName: 'Tony Stark', ProjectName: 'CIC', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Pending', currentlyusing: 'Facebook', proStatus: 'Unproductive', icon: 'assets/common/images/Activities/Facebook.png' },
        { id: 5, MemberName: 'Tim Cook', ProjectName: 'ATP jobs', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Approved', currentlyusing: 'Adobe XD', proStatus: 'Productive', icon: 'assets/common/images/Activities/AdobeIcon.png' },
        { id: 6, MemberName: 'Franis Lawrence', ProjectName: 'ATP jobs', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', currentlyusing: 'Absent', proStatus: ' ', icon: 'assets/common/images/Activities/absentIcon.svg' },
        { id: 7, MemberName: 'Leo Messi', ProjectName: 'WFM One', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Pending', currentlyusing: 'Outlook', proStatus: 'Neutral', icon: 'assets/common/images/Activities/microsoft.png' },
        { id: 8, MemberName: 'Steve Rogers', ProjectName: 'ITP', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Approved', currentlyusing: 'Facebook', proStatus: 'Unproductive', icon: 'assets/common/images/Activities/Facebook.png' },
        { id: 9, MemberName: 'Tony Stark', ProjectName: 'CIC', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Pending', currentlyusing: 'Adobe XD', proStatus: 'Productive', icon: 'assets/common/images/Activities/AdobeIcon.png' },
        { id: 10, MemberName: 'Tim Cook', ProjectName: 'ATP jobs', ArrivedAt: '09:30 AM', ProductiveTime: '6h 28m', ITPTime: '6h 28m', LeftAt: '-', AtWork: '7h 20m', Status: 'Approved', currentlyusing: 'Absent', proStatus: ' ', icon: 'assets/common/images/Activities/absentIcon.svg' }
    ];

    constructor() { }

    ngOnInit(): void {
    }

    //For Toggling
    toggleShow() {

        this.isShown = !this.isShown;
        this.isShown_grid = !this.isShown_grid;
    }

    toggleShow_grid() {

        this.isShown_grid = !this.isShown_grid;
        this.isShown = !this.isShown;

    }

    //Event Emitter for 3rd tab Opening
    myprofileDisplay() {
        
        this.mydashboardProfiletab.emit('1');
    }

}
